/**
 * 결제 취소 훅
 * FSD: features/subscription/payment-history/hooks
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { transactionAPI } from '../api/transaction-api';

export const usePaymentCancel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { tid: string; amount: string; reason: string }) =>
      transactionAPI.cancelPayment(data.tid, data.amount, data.reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
};
